import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Hero from "@/components/sections/Hero";
import TextMarquee from "@/components/sections/Marquee";
import Services from "@/components/sections/Services";
import Manifesto from "@/components/sections/Manifesto";
import Stats from "@/components/sections/Stats";
import InquiryForm from "@/components/sections/InquiryForm";

export default function Home() {
    return (
        <div className="bg-abyss grain min-h-screen">
            <Navbar />
            <main>
                <Hero />
                <TextMarquee />
                <Services />
                <Manifesto />
                <Stats />
                <InquiryForm />
            </main>
            <Footer />
        </div>
    );
}
